<template>
  <v-container fluid class="px-12 py-4" v-if="record">
    <v-row>
      <v-col cols="8">
        <breadcrumbs></breadcrumbs>
        <h1>Organization Form</h1>
      </v-col>
    </v-row>
    <v-divider class="mb-4"></v-divider>
    <v-form @submit.prevent="onSubmit" v-model="valid" class="mt-10">
      <label class="och-label">Organization Name</label>
      <v-text-field
        v-model="record.name"
        outlined
        :rules="requiredRule"
      ></v-text-field>

      <label class="och-label">Abbreviation</label>
      <unique-text-field
        attributeName="abbreviation"
        entityName="organization"
        :entityIdValue="organizationId"
        :list="organizationList"
        v-model="record.abbreviation"
        outlined
        required
      ></unique-text-field>
      <div class="text-right">
        <v-btn
          @click="
            $router.push({
              name: `${$route.query.redirect || 'structureList'}`,
            })
          "
          class="mr-3"
          color="grey darken-2"
          :disabled="!valid"
          outlined
          >Cancel</v-btn
        >
        <v-btn
          @click="save"
          color="primary"
          class="elevation-0"
          :disabled="!valid"
          >Save</v-btn
        >
      </div>
    </v-form>
  </v-container>
</template>

<script>
import { mapActions, mapState } from "vuex";
import Breadcrumbs from "@/views/Breadcrumbs";
import UniqueTextField from "@/components/static/UniqueTextField";

export default {
  components: {
    Breadcrumbs,
    UniqueTextField,
  },
  computed: {
    ...mapState({
      canCreateOrganization: state =>
        state.session.user.permission.organization.create,
      organizationList: state => state.organization.list,
      organizationId: state => state.session.user.organizationId,
      record: state => state.organization.record,
    }),
    redirect() {
      return this.$route.query.redirect;
    },
  },
  async created() {
    await this.getOrganization(this.organizationId);
    await this.getOrganizationList();
    if (this.record.addressId) {
      await this.getAddress(this.record.addressId);
    }
  },
  data() {
    return {
      requiredRule: [v => !!v || "Required field"],
      valid: true,
    };
  },
  methods: {
    async save() {
      this.record.abbreviation = this.record.abbreviation.toUpperCase();

      const { abbreviation, name, organizationId } = this.record;
      const attributeValueHash = {
        abbreviation,
        name,
        organizationId,
      };

      try {
        await this.updateOrganization([
          this.organizationId,
          attributeValueHash,
        ]);
        this.$notifySuccess({
          message: "Organization has been successfully updated.",
        });
      } catch (e) {
        if (e.response && e.response.status === 403) {
          return this.$notifyError({
            message: `You do not have permission to update organizations.`,
          });
        }
        return this.$notifyError({
          message: "Could not save organization.",
        });
      }

      this.$router.push({ name: this.redirect || "structureList" });
    },
    ...mapActions({
      getOrganization: "organization/getByOrganizationId",
      getOrganizationList: "organization/list",
      updateOrganization: "organization/update",
    }),
  },
};
</script>
